import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { IllustrationShape } from 'client/constants/tax/shapes';

export const defaultIllustration = 'https://images.contentful.com/heg7gyzix6dq/7ziR9AvnpeY2m6OyUAWQMO/2ad53f2306da2bbcaf55ae0b6cec71b4/generic-profession.svg';

const typeMap = {
  svg: 'image/svg+xml',
  png: 'image/png',
};

const propTypes = {
  illustration: IllustrationShape,
  alt: PropTypes.string,
  preferredType: PropTypes.string,
  fallbackUrl: PropTypes.string,
};
const defaultProps = {
  illustration: null,
  alt: '',
  preferredType: 'svg',
  fallbackUrl: defaultIllustration,
};

export function getImageUrl(images, preferredType, fallbackUrl = defaultIllustration) {
  if (Array.isArray(images) && images.length) {
    const preferredImage = _.find(images, { contentType: typeMap[preferredType] });
    if (preferredImage && preferredImage.url) {
      return preferredImage.url;
    }

    if (images[0].url) {
      return images[0].url;
    }
  }

  return fallbackUrl;
}

export default class Illustration extends PureComponent {
  static propTypes = propTypes;
  static defaultProps = defaultProps;

  constructor(props) {
    super(props);
    const images = props.illustration && props.illustration.images;
    this.imageUrl = getImageUrl(images, props.preferredType, props.fallbackUrl);
  }

  render() {
    return <img className="illustration" src={this.imageUrl} alt={this.props.alt} />;
  }
}
